import { fadeInUp, fadeIn } from "react-animations";
import styled, { keyframes } from "styled-components";
import Color from "../../assets/styles/colors";

const fadeInAnimation = keyframes`${fadeIn}`;
const fadeInUpAnimation = keyframes`${fadeInUp}`;

export const Div = styled.div``;

export const Row = styled.div``;

export const Col = styled.div``;

export const CardLink = styled.a``;

export const ContainerEmpty = styled.div`
  animation: 1s ${fadeInAnimation};
`;

export const EmptyMsgCarts = styled.div`
  color: ${(props) =>
    props.theme.isDarkTheme
      ? Color.textColorBlackSeven
      : Color.textColorBlackOne};
`;

export const EmptyMsgDesCarts = styled.div`
  color: ${(props) =>
    props.theme.isDarkTheme
      ? Color.textColorBlackFive
      : Color.textColorBlackOne};
`;

export const CardContainerFood = styled.div`
  display: block;
  animation: 1s ${fadeInAnimation};
`;

export const ContainerFood = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
`;

export const ContainerQuantity = styled.div`
  position: absolute;
  bottom: 15px;
  left: 10px;
`;

export const FoodImg = styled.img``;

export const FoodName = styled.div`
  color: ${(props) =>
    props.theme.isDarkTheme
      ? Color.textColorBlackSeven
      : Color.textColorBlackFor};
`;

export const FoodPrice = styled.div`
  font-weight: bold;
  color: ${(props) =>
    props.theme.isDarkTheme ? Color.textColorBlackSeven : Color.colorRed};
`;

export const FoodPriceDis = styled.span`
  font-size: 11px;
  color: ${(props) =>
    props.theme.isDarkTheme
      ? Color.textColorBlackEight
      : Color.textColorBlackFor};
`;

export const ItemRight = styled.span`
  font-size: 13px;
  color: ${(props) =>
    props.theme.isDarkTheme
      ? Color.textColorBlackEight
      : Color.textColorBlackTree};
`;

export const ItemLeft = styled.span`
  font-size: 13px;
  color: ${(props) =>
    props.theme.isDarkTheme
      ? Color.textColorBlackEight
      : Color.textColorBlackTree};
`;

export const ItemRightBold = styled.span`
  font-size: 13px;
  color: ${(props) =>
    props.theme.isDarkTheme
      ? Color.textColorBlackSeven
      : Color.textColorBlackSix};
`;

export const ItemLeftBold = styled.span`
  font-size: 13px;
  color: ${(props) =>
    props.theme.isDarkTheme
      ? Color.textColorBlackSeven
      : Color.textColorBlackSix};
`;

export const ItemPrice = styled.span`
  font-size: 13px;
  color: ${(props) =>
    props.theme.isDarkTheme ? Color.colorRed : Color.colorRed};
`;

export const RightMBorder = styled.div`
  border-bottom: 2px solid
    ${(props) =>
      props.theme.isDarkTheme
        ? Color.textColorBlackFor
        : Color.textColorBlackSeven};
  padding-bottom: 15px;
`;

export const SideBarContainer = styled.div`
  animation: 1s ${fadeInUpAnimation};
`;

export const ItemTrash = styled.div`
  position: absolute;
  left: -5px;
  top: 0;
  color: #fff;
`;

export const TrashIcon = styled.i`
  color: ${(props) =>
    props.theme?.isDarkTheme ? Color.colorWhite : Color.colorRed};
`;

export const FoodOfferPercent = styled.div`
  border: 1px solid ${Color.colorAppOrange};
  padding: 4px;
  border-radius: 6px;
  color: ${(props) =>
    props.theme?.isDarkTheme
      ? Color.textColorBlackFive
      : Color.textColorBlackOne};
  font-weight: bold;
`;
